import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {topic_recommendation_report_template} from "../components/templates/topic_recommendation_report_template";

declare var ko: any;

export class topic_recommendation_report extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected topicRecommendationReportTemplate: topic_recommendation_report_template;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(): string{

        return "topic_recommendation_report";
    }

    buildContent(): Array<Element>{
        // create the tag list
        this.topicRecommendationReportTemplate = new topic_recommendation_report_template("list", this.viewModel, this);
        this.template = this.topicRecommendationReportTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Topic Recommendation Report");

        return [this.topicRecommendationReportTemplate.build()];
    }

    public fillPage() : void{

        this.updateViewModelFromPath();
        this.getSearchPresetsListData();
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.topicRecommendationReportTemplate.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.topicRecommendationReportTemplate.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    public filterList(){
        // LOADING : starts
        this.loadingIn(document.getElementById("list-results"));

        let usrReq_url: string = '/api/topicRecommendationReport/brand/' + this.getVnAppZone().app.params.idBrand + '/get';
        let subViewModel = this.topicRecommendationReportTemplate.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'topic_recommendation_report');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(document.getElementById("list-results"));
        }
    }

    protected updateList(responseParsed: any) {

        let records = responseParsed.data.data.report;
        for(let record of records){
            record = this.topicRecommendationReportTemplate.initRecordChart(record);
        }
        this.topicRecommendationReportTemplate.setRecords(records);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.topicRecommendationReportTemplate.setResultInfo(responseParsed.data.totalCount, responseParsed.data.totalPage, execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.data.totalCount);
    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tags) {
                    responseParsed.data.tags.forEach(tag => tag.name = `${tag.name} ${tag.formattedTagTypeAndDataset}`);
                    obj.topicRecommendationReportTemplate.tagFilter.setOptions(responseParsed.data.tags);
                }

            });
        }
    }

    public getTagTypesSuggestion(keyword, idElement) {

        if( "getTagTypesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagTypesSuggestion"].cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/search/tag/type/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagTypesSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagTypesSuggestion'].onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdls['getTagTypesSuggestion'].execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {


                let response = JSON.parse(req.request.response);

                if (response.data.tagTypes) {
                    obj.topicRecommendationReportTemplate.tagTypeFilter.setOptions(response.data.tagTypes);
                }

            });
        }
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected tagsListReorder(){

        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    // search preset section

    public setDefaultStatusFilters(){

    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.topicRecommendationReportTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.topicRecommendationReportTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
            });
        }
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterAutocomplete_tagFilter" )
        {

            let filterTypes = this.topicRecommendationReportTemplate.tagFilter.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.topicRecommendationReportTemplate.tagFilter.setOptions([]);

            }
        }
        else if ( idElement == "filterAutocomplete_tagTypeFilter" )
        {

            let filterTypes = this.topicRecommendationReportTemplate.tagTypeFilter.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.topicRecommendationReportTemplate.tagTypeFilter.setOptions([]);

            }
        }
    }

    protected getSuggestions(keyword, idSourceElement) {

        if (idSourceElement == "filterAutocomplete_tagFilter") {

            let filterTypes = this.topicRecommendationReportTemplate.tagFilter.getTemplateViewModel();
            this.getTagsSuggestion(filterTypes.inputText(), 5);

        }
        else if (idSourceElement == "filterAutocomplete_tagTypeFilter") {

            let filterTypes = this.topicRecommendationReportTemplate.tagTypeFilter.getTemplateViewModel();
            this.getTagTypesSuggestion(filterTypes.inputText(), 5);

        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocomplete_tagFilter") {
            let tag = this.topicRecommendationReportTemplate.tagFilter.getTemplateViewModel().optionObj();
            if (tag) {
                let currentTags = this.topicRecommendationReportTemplate.getTemplateViewModel().tagsArray();
                let addTag = true;
                for(let i =0; i<currentTags.length; i++){
                    if(currentTags[i].id == tag.id){
                        addTag = false;
                        break;
                    }
                }
                if(addTag){
                    currentTags.push(tag);
                    this.topicRecommendationReportTemplate.getTemplateViewModel().tagsArray(currentTags);
                    this.filterSimpleOnChange();
                }
                this.topicRecommendationReportTemplate.tagFilter.clearSelectedOption();
            }
        }
        else if (idElement == "filterAutocomplete_tagTypeFilter") {
            let tagType = this.topicRecommendationReportTemplate.tagTypeFilter.getTemplateViewModel().optionObj();
            if (tagType) {
                let currentTagTypes = this.topicRecommendationReportTemplate.getTemplateViewModel().tagTypesArray();
                let addTagType = true;
                for(let i =0; i<currentTagTypes.length; i++){
                    if(currentTagTypes[i].id == tagType.id){
                        addTagType = false;
                        break;
                    }
                }
                if(addTagType){
                    currentTagTypes.push(tagType);
                    this.topicRecommendationReportTemplate.getTemplateViewModel().tagTypesArray(currentTagTypes);
                    this.filterSimpleOnChange();
                }
                this.topicRecommendationReportTemplate.tagTypeFilter.clearSelectedOption();
            }
        }
    }

    protected onAutocompleteInputClear(idElement){

        if (idElement == "filterAutocomplete_tagFilter") {
            this.topicRecommendationReportTemplate.getTemplateViewModel().tagsArray([]);
        }
        else if (idElement == "filterAutocomplete_tagTypeFilter") {
            this.topicRecommendationReportTemplate.getTemplateViewModel().tagTypesArray([]);
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/topic_recommendation_report.ts